<template>
  <o-modal :active="isActive" :canCancel="false" class="modal-sm">
    <div class="modal-card">
      <!-- Modal Header -->
      <header class="modal-card-head">
        <h4 class="modal-card-title">
          Create Project
          <span
            class="line-height required-label is-size-5 is-italic is-pulled-right mr-0 has-text-weight-normal"
          >
            * required
          </span>
        </h4>
        <!-- <div class="is-divider-vertical"></div> -->
        <!-- <i class="icon-close is-clickable" @click="$emit('close')"></i> -->
      </header>
      <!-- Modal Body -->
      <div class="modal-card-body is-visible p-0">
        <!-- <div class="py-2 px-5">
          <h4
              class="is-size-3"
            >
            {{orderDetailsTitle}}
            </h4>
        </div> -->
        <div class="column">
          <div class="columns">
            <div class="column pt-0">
              <div class="field">
                <div class="field-label">
                  <label class="label is-size-3"> Project Name *</label>
                </div>
                <div class="field-body">
                  <div class="control">
                    <input
                      class="input"
                      v-model.trim="project.name"
                      placeholder="Enter name (3 or more characters)"
                    />
                  </div>
                </div>
              </div>
              <div class="field">
                <div class="field-label">
                  <label class="label">Project Owner *</label>
                </div>
                <div class="field-body">
                  <div class="field is-expanded">
                    <div class="control">
                      <mf-multi-select
                        v-model="project.projectOwner.email"
                        placeholder="Owner Email"
                        :preselect-first="true"
                        :options="usersEmail"
                        :searchable="true"
                        :allow-empty="false"
                        class="pendo-owner-select"
                				@update:modelValue="changeOwner"
                      >
                      </mf-multi-select>
                    </div>
                  </div>
                </div>
              </div>
							<div class="field">
                <div class="field-label">
                  <label class="label">Default Production Order Tab :</label>
                </div>
                <div class="field-body">
                  <div class="field is-expanded">
                    <div class="control">
                      <mf-multi-select
                        v-model="editSettingTab"
                        placeholder="Select Option"
                        :preselect-first="true"
                        :options="editSettingTabs"
                        :searchable="true"
                        :allow-empty="false"
                        class="pendo-pm-default-tab-select"
												label="name"
                				track-by="value"
                				@update:modelValue="updateEditTabSetting"
                      >
                      </mf-multi-select>
                    </div>
                  </div>
                </div>
              </div>
							<div class="field">
                <div class="field-label">
                  <label class="label">Order Onsite-Date Reminder (Range 1-7)</label>
                </div>
                <div class="field-body">
                  <div class="field is-expanded">
                    <div class="control">
											<div class="column">
												<div class="columns">
													<div class="column is-narrow pl-0">
														<o-switch class="is-size-3 has-text-black-bis has-text-weight-bold"
															v-model="project.projectSettings[0].toNotify"
															@click="remainderValidation">
														</o-switch>
													</div>
													<div class="column is-2 pl-0 is-narrow">
														<input type="number"
															class="input"
															step="any"
															v-model.number="project.projectSettings[0].notifications"
															:disabled="!project.projectSettings[0].toNotify" :min="1"
															:max="7" @input="remainderValidation" @blur="updateVal">
													</div>
													<div class="column">
														<span class="has-text-dark is-size-3 line-height">Day(s) before</span>
													</div>
												</div>
											</div>
                    </div>
                  </div>
                </div>
              </div>
							<div class="field">
                <div class="field-label">
                  <label class="label">Project Inventory Location *</label>
                </div>
                <div class="field-body">
                  <div class="field is-expanded">
                    <div class="control">
                      <mf-multi-select
                        v-model="project.projectSettings[0].projectInventoryLocation"
                        placeholder="Select Option"
                        :preselect-first="true"
                        :options="inventoryLocationList"
                        :searchable="true"
                        :allow-empty="false"
												group-values="val" group-label="key"
												label="name"
                      >
                      </mf-multi-select>
                    </div>
                  </div>
                  <div class="field">
                    <span class="line-height has-text-dark">
                      (<span class="has-text-weight-bold">NOTE</span>: Project Inventory Location cannot be edited once any production order has moved to the manufacturing stage)
                    </span>
                  </div>
                </div>
              </div>
            </div>
						<div class="column pt-0">
							<div class="field">
                <div class="field-label">
                  <label class="label is-size-3">Project ID *</label>
                </div>
                <div class="field-body">
                  <div class="control">
                    <input
                      class="input"
                      v-model.trim="project.projectSettings[0].customId"
                      placeholder="Project Id"
                    />
                  </div>
                </div>
              </div>
							<div class="field">
                <div class="field-label">
                  <label class="label is-size-3">Location *</label>
                </div>
                <div class="field-body">
                  <div class="control">
                    <input
                      class="input"
                      v-model.trim="project.location.name"
                      placeholder="Location Name"
                    />
                  </div>
									<div class="control mt-2">
                    <input
                      class="input"
                      v-model.trim="project.location.street"
                      placeholder="Street"
                    />
                  </div>
									<div class="control mt-2">
                    <input
                      class="input"
                      v-model.trim="project.location.city"
                      placeholder="City"
                    />
                  </div>
									<div class="control mt-2">
                    <input
                      class="input"
                      v-model.trim="project.location.state"
                      placeholder="State"
                    />
                  </div>
									<div class="control mt-2">
                    <input
                      class="input"
                      v-model.trim="project.location.zipcode"
                      placeholder="Zipcode"
                    />
                  </div>
                </div>
              </div>
              <div class="field">
                <div class="field-label">
                  <label class="label is-size-3">Thumbnail</label>
                </div>
                <div v-if="getPresignedUrl" class="is-flex is-flex-direction-column">
                  <div class="">
                    <button class="button has-background-black-bis is-medium"
                      @click="removeThumbnail">Delete</button>
                  </div>
                  <div class="empty-box">
                    <img width="200" :src="getPresignedUrl">
                  </div>
                </div>
                <div v-else>
                  <mf-file-picker
                    accept="image/png, image/jpeg"
                    path="projects/addAvatar"
                    filePath="imageUrl"
                    :multiple="false"
                    :isImageUpload="true"
                    :hideLimitText="true"
                    @onInput="(file) => updateThumbnail(file)"
                  >Add Image</mf-file-picker>
                  <div class="empty-box"></div>
                </div>
              </div>
						</div>
          </div>
        </div>
      </div>

      <!-- Modal Footer -->
      <footer
        class="modal-card-foot is-justify-content-flex-end is-align-items-center"
      >
        <div class="column is-narrow">
          <div>
            <button class="button is-outlined" @click="$emit('close')">
              Cancel
            </button>
            <button
              class="button has-background-black-bis"
              @click="createProject"
              :disabled="disableSave"
            >
              Create / View Project
            </button>
          </div>
        </div>
      </footer>
      <o-loading
        :full-page="true"
        :active="isLoading"
        :can-cancel="true"
      ></o-loading>
    </div>
  </o-modal>
</template>
<script>
import { reactive, toRefs, computed, onMounted, onBeforeMount } from "vue";
import _ from "lodash";
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import { useRouter } from 'vue-router';
import Projects from '@/models/Projects';
import QtyInput from '@/components/fields/QtyInput.vue';
import Locations from '@/models/Locations';
import MfFilePicker from '@/components/MfFilePicker.vue';
import s3FileAccess from '@/models/SimpleStorageService'

export default {
  name: "CreateProject",
  emits: ["close", "create"],
  props: {
		isActive: {
			type: Boolean,
			default: false
		},
		user: {
			type: Object,
			default: () => {}
		}
	},
  components: {
    QtyInput,
    'mf-file-picker': MfFilePicker,
  },
  setup(props, { emit }) {
    const store = useStore();
    const toast = useToast();
		const router = useRouter();

    const user = store.state.userData;

		const editSettingTabs = [
			{ name: 'Work Steps', value: 'runs' },
			{ name: 'Items', value: 'items' },
			{ name: 'Tasks', value: 'Checklist' },
			{ name: 'Materials', value: 'materials' },
		]

    const data = reactive({
      companyData: {},
			isLoading: false,
			allCompanyUsers: [],
			usersEmail: [],
			inventoryLocationList: [],
			editSettingTab: { name: 'Work Steps', value: 'runs' },
      presignedUrl: '',
			project: {
        status: 'Active',
        contactEmail: user.email,
        isTemplateProject: false,
        imageUrl: '',
				location: {
          name: '',
          street: '',
        },
        purchaseOrderNumber : {
          nextNumber: '00001',
          prefix: '',
        },
				linkedProjectSetting: {},
        projectOwner: {
          firstName: user.firstName,
          lastName: user.lastName,
          company: {
            _id: user.company,
            name: user.companyName,
          },
          levels: [],
          zones: [],
          mobilePhone: user.mobilePhone,
          officePhone: user.officePhone,
          email: user.email,
        },
        projectSettings: [
          {
            status: 'Active',
            toNotify: true,
            notifications: 1,
            isPrivate: true,
            isPTEnabled: true,
            companyId: user.company._id || user.company,
						editSettingTab: 'runs',
						projectInventoryLocation: {}
          },
        ],
      }
		});

		onBeforeMount(async () => {
    	data.companyData = store.state.companyData;
			if (_.isEmpty(data.companyData)) {
				await store.dispatch('getCompanyData')
    		data.companyData = store.state.companyData;
			}
			data.allCompanyUsers = await Projects.allMyCompanyUsers();
      data.usersEmail = _.map(data.allCompanyUsers, 'email');
			const locations = [];
      const project = [];
      const [GI] = await Projects.allProjects({ isGI: true });
      if (GI) project.push(GI._id);
      if (!_.isEmpty(project)) {
        const locs = await Locations.allLocationForUser({
          companyId: data.project.projectSettings[0].companyId,
          project,
        });
        locations.push(...locs);
      } else {
        const compLocations = (await Locations.allCompanyLocations({
          companyId: data.project.projectSettings[0].companyId,
          type: 'company_location',
        })).data;
        locations.push(...compLocations);
      }
      data.inventoryLocationList = Locations.groupLocations(
        _.uniq(locations),
        store.state.companyData,
      );

      const defaultInventoryLocation = _.find(locations, 'defaultInventoryLocation');
      data.project.projectSettings[0].projectInventoryLocation = defaultInventoryLocation;
		})

		const projIdValidation = (projId) => {
			const regex = '^[a-zA-Z0-9-]+$'
			if (_.isEmpty(projId) || projId.trim().length < 3 || projId.trim().length > 16
			|| !RegExp(regex).test(projId)) return false
			return true
		}

		const validateZip = (zipCode, showError) => {
    	// US team requirement https://github.com/manufacton/Rio/issues/10237
			zipCode = !_.isEmpty(zipCode) ? zipCode : '';
			if (!_.inRange(zipCode.length, 1, 25)) {
				if (showError) {
					toast.error('Valid range for Zip length is 1 - 24!')
				}
				return false;
			}
			return true;
		}

		const validations = () => {
      if (_.isEmpty(data.project.name) || data.project.name.trim().length < 3) {
        toast.error('Please Check the inputs for project name');
        return false;
      } if (data.project.isTemplateProject !== true
        && !projIdValidation(data.project.projectSettings[0].customId)) {
        toast.error('Please enter valid Project ID (Project ID can only contain 3 to 16 alpha-numeric characters and dashes)');
        return false;
      } if (_.isEmpty(data.project.projectSettings[0].projectInventoryLocation)) {
        toast.error('Project Inventory Location is Required');
        return false;
      } if (data.project.isTemplateProject
        && (data.project.status === 'Archived'
          || data.project.projectSettings[0].status === 'Archived')) {
        toast.error('Template Project can not be Archive');
        return false;
      } if (data.project.projectSettings[0].toNotify
        && (!data.project.projectSettings[0].notifications
         || data.project.projectSettings[0].notifications < 1
         || data.project.projectSettings[0].notifications > 7)) {
        toast.error('Please set reminder in the range 1 - 7');
        return false;
      } if (_.isEmpty(data.project.location)) {
        toast.error('Please fill project location details');
        return false;
      } if (!_.isEmpty(data.project.location)) {
        if (_.trim(data.project.location.name).length < 3) {
          toast.error('Location name should be atleast 3 characters long!');
          return false;
        } if (_.trim(data.project.location.street).length < 3) {
          toast.error('Street name should be atleast 3 characters long!');
          return false;
        } if (_.trim(data.project.location.city).length < 3) {
          toast.error('City name should be atleast 3 characters long!');
          return false;
        } if (_.trim(data.project.location.state).length < 2) {
          toast.error('State name should be atleast 2 characters long!');
          return false;
        } if (!validateZip(data.project.location.zipcode, true)) {
          return false;
        }
      }
      return true;
    }

		const changeOwner = (selectedVal) => {
			const newOwner = _.find(
        data.allCompanyUsers,
        (companyUser) => companyUser.email === selectedVal,
      );
      data.project.projectOwner.name = newOwner.name;
      data.project.contactEmail = newOwner.email;
		}
		
		const updateEditTabSetting = (opt) => {
			data.project.projectSettings[0].editSettingTab = opt.value;
    }

		const remainderValidation = () => {
      if (data.project.projectSettings[0].notifications < 0
      || data.project.projectSettings[0].notifications > 7) { data.project.projectSettings[0].notifications = 1; }
    }

		const updateVal = () => {
			if (data.project.projectSettings[0].notifications < 1
      || data.project.projectSettings[0].notifications > 7) { data.project.projectSettings[0].notifications = 1; }
		}

    const getPresignedUrl = computed(() => {
      return data.presignedUrl
    })

    const updateAvatarRender = async () => {
      const fileGuid = _.get(data.project, 'imageUrl.fileGuid', '');
      let type = 'project';
      const params = {
        type,
        id: fileGuid,
      }
      if (fileGuid !== '') {
        params.projectId = '000000000000000000000000'
        const { presignedUrl } = await s3FileAccess.getS3File(params);
        data.presignedUrl = presignedUrl;
        return true;
      }
    }

    const updateThumbnail = async (file) => {
      data.project.imageUrl = file
      await updateAvatarRender()
    }

    const removeThumbnail = () => {
      data.project.imageUrl = ''
      data.presignedUrl = ''
    }

		const createProject = async () => {
      if (validations()) {
        data.isLoading = true;
        try {
          data.project.linkedProjectSetting = data.project.projectSettings[0]
          const res = await Projects.update(data.project);
          // route redirecting to project card view
          data.isLoading = false;
					toast.success('Project Created')
          router.push({
            name: 'project-view',
            params: {
              id: res._id,
            },
          });
        } catch (errors) {
					console.error('Error: ', errors)
					toast.error('Error: ', errors.data._errmsg)
        } finally {
					data.isLoading = false
				}
      }
    }

    return {
      ...toRefs(data),
			createProject,
			changeOwner,
			updateEditTabSetting,
			editSettingTabs,
			remainderValidation,
			updateVal,
      updateThumbnail,
      getPresignedUrl,
      removeThumbnail
    };
  },
};
</script>
<style scoped>
  .modal-card-head {
      background-color: #fff !important;
      border-bottom: none !important;
    }
  .modal-card-foot {
    border-top: 1px solid #84888c;
      background-color: #fff !important;
  }
  ::v-deep(.o-field.has-text-centered.drag-drop) {
    text-align: start !important;
  }
  ::v-deep(.o-upl) {
    height: auto !important;
    display: block !important;
  }
  .empty-box {
    height: 200px !important;
  }
</style>
